import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import TextInputField from '../../infra/components/formInput/CustomTextInput' 
import ComboboxInput from '../../infra/components/formInput/ComboboxInput' 

import ActionGet from '../../store/action/InvalidReply/View'
import ActionDelete from '../../store/action/InvalidReply/Delete'
import ActionEdit from '../../store/action/InvalidReply/Edit'
import ActionAdd from '../../store/action/InvalidReply/Add'
import { ListTemplateType } from '../../store/local/liststicker'


class Page extends Component{
    constructor(props){
        super(props)
        this.state = {
            form: fromJS({
                "type": "",
                "message": "",
                "url": "",
                "status": ""
            }),
            datatime: new Date().getTime()
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount(){
        this.props.actionGet()
    }
    
    handleChange(field, value) {
        var formVal = this.state.form;
        formVal = formVal.set(field,value); 
        this.setState({ form:formVal })
    }

    static getDerivedStateFromProps(props,state){
        if(props.data.size > 0){
            if(props.datatime !== state.datatime){
                return { 
                    form: props.data, 
                    datatime: props.datatime,
                }
            }
        }
      
    }

    async handleSubmit(dispatch) {
        const { form } = this.state;
        const { data } = this.props;
        
        var vform = form;    
        var param = {
          'data': vform
        }
        
        var response = '';
        if(data.size === 0){
          response = await this.props.actionAdd(param);
        }else{
          response = await this.props.actionEdit(param);
        }
    
        if(response !== ''){
          if(response.ok){
            this.props.actionGet()
            toast.success("Submit Success!", toast.POSITION.TOP_RIGHT)
          }else{
           toast.error("Submit Failed!", toast.POSITION.TOP_RIGHT)
          }
        }
      }

    render(){
        const { form } = this.state
        let showmessage=''
        let showurl = ''
        if(form.get('type') == "sticker"){
            showmessage = 'hide'
        }else{
           showmessage = ''
        }
        if(form.get('type') == "text"){
            showurl = 'hide'
        }else{
            showurl = ''
        }
        return(
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                    Invalid Reply
                    </h4>
                </div>
            <div className="card">
                <div className="body">    
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Type</span>
                        <div className="col-sm-10">
                           
                            <ComboboxInput
                    field='type'
                    value={form.get('type')}
                    options={fromJS({
                        'source': ListTemplateType(),
                        'value': 'value',
                        'label': 'label'
                    }) }
                    onChange={(field, value, label) => this.handleChange(field,value, label)}
                    placeholder="Type"
                    disabled={false}
                    hasError={false}
                />  
                        </div>
                    </div>

                    <div className= {`row no-margin-bottom ${showmessage}`}>
                        <span className="col-sm-2">Message</span>
                        <div className="col-sm-10">
                            <TextInputField className="form-control"
                            textarea
                                field={'message'}
                                value={ form.get('message')}
                                onChange={(field, value) => this.handleChange(field,value)}
                                placeholder="message"
                            />
                        </div>
                    </div>

                    <div className={`row no-margin-bottom ${showurl}`}>
                        <span className="col-sm-2">Url</span>
                        <div className="col-sm-10">
                            <TextInputField className="form-control"
                                field={'url'}
                                value={ form.get('url')}
                                onChange={(field, value) => this.handleChange(field,value)}
                                placeholder="url"
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2"></span>
                        <div className="col-sm-10">
                            <button type="button"
                                className="btn btn-wide btn-success"
                                onClick={ this.handleSubmit }>
                                    Submit
                            </button>
                        </div>
                    </div>

                </div>
            </div>
            </div>
        )
    }
}


export default connect(
    (state) => {
        return {
          data: state.user.invalidreply,
          datatime: state.user.invalidreplytime
        }
    },
    dispatch => bindActionCreators({
        actionGet: ActionGet,
        actionDelete: ActionDelete,
        actionEdit: ActionEdit,
        actionAdd: ActionAdd,
    }, dispatch),
  )(Page);